// PurchaseOrderViewIntro Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import Typo from '../../../common/typography/typo/typo.jsx'
import classnames from 'classnames'

class PurchaseOrderViewIntro extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      editable: false
    }

    this._references = {
      editor: React.createRef()
    }
  }

  static get propTypes () {
    return {
      purchaseOrder: PropTypes.object,
      onChange: PropTypes.func,
      onDelete: PropTypes.func,
      disableEdit: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      purchaseOrder: null,
      onChange: null,
      onDelete: null,
      disableEdit: false
    }
  }

  show (bEditable) {
    this.setState({ active: true, editable: bEditable })
  }

  hide () {
    this.setState({ active: false, editable: false })
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate (nextProps, nextState) {
    if (nextProps.purchaseOrder && nextProps.purchaseOrder.introText !== null) {
      nextState.active = true
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._references.editor.current &&
      prevState.editable !== this.state.editable
    ) {
      this._references.editor.current.focus()
    }
  }

  render () {
    const purchaseOrder = this.props.purchaseOrder
    if (!purchaseOrder || purchaseOrder.introText === null) {
      return <div className='purchaseorder-viewintro' />
    }

    const className = classnames('purchaseorder-viewintro', {
      active: this.state.active,
      'cursor-pointer': this._isReadOnly()
    })
    const clickHandler = this._isReadOnly()
      ? this._onEdit.bind(this)
      : undefined
    const content = this._isReadOnly()
      ? this._renderReadOnlyContent()
      : this._renderEditableContent()

    return (
      <div className={className}>
        <div className='content' onClick={clickHandler}>
          {content}
        </div>
      </div>
    )
  }

  /* Private functions */
  _onBlur (value, _ev) {
    this.props.purchaseOrder.introText = value || null
    this.setState({ editable: false })
    if (this.props.onChange) {
      this.props.onChange(value)
    }
  }

  _onDelete (ev) {
    ev.preventDefault()

    if (this.props.onDelete) {
      this.props.onDelete()
    }
  }

  _onEdit () {
    if (this.props.disableEdit) {
      return false
    }

    this.setState({ editable: true })
  }

  _renderReadOnlyContent () {
    return (
      <Typo alternate className='wysiwygtypo'>
        <div
          dangerouslySetInnerHTML={{
            __html: this.props.purchaseOrder.introText
          }}
        />
      </Typo>
    )
  }

  _renderEditableContent () {
    return (
      <form method='post' noValidate action='#'>
        <WysiwygEditor
          placeholder='expense.view.placeholderIntro'
          ref={this._references.editor}
          className='wysiwygtypo'
          value={this.props.purchaseOrder.introText}
          onBlur={this._onBlur.bind(this)}
        />
        <IconButton
          icon='common-item-delete'
          title='expense.view.removeIntro'
          canHover={false}
          size='small'
          className='purchaseview'
          onClick={this._onDelete.bind(this)}
        />
      </form>
    )
  }

  _isReadOnly () {
    return !this.state.editable
  }
}

export default PurchaseOrderViewIntro
